import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

const CasesTable = lazy(
	() => import('@/features/air/multi-tenant/components/cases-table'),
)

export const Route = createFileRoute('/_dashboard/multi-tenant/_layout/cases')({
	component: CasesTab,
	pendingComponent: RouteSkeleton,
})

function CasesTab() {
	return (
		<Suspense fallback={<TableFullSkeleton rows={10} />}>
			<CasesTable />
		</Suspense>
	)
}

function RouteSkeleton() {
	return <TableFullSkeleton rows={10} />
}
